"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCompactSliderPoint = exports.StyledCompactSliderControl = exports.StyledCompactSliderTrackArea = exports.StyledCompactSliderTrackLine = exports.StyledCompactSliderWrapper = exports.compactSliderThumbSize = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const constants_1 = require("./helpers/constants");
exports.compactSliderThumbSize = '11px';
const trackConfig = {
    height: '1px',
    areaClickHeight: '11px'
};
const pointConfig = {
    width: '11px',
    internalCircleWidth: '3px'
};
exports.StyledCompactSliderWrapper = styled_components_1.default.div `
    position: relative;
    height: ${exports.compactSliderThumbSize};
    user-select: none;
    width: ${({ size }) => size};
    min-width: ${constants_1.MIN_WIDTH_COMPACT_SLIDER};
`;
exports.StyledCompactSliderWrapper.displayName = 'CompactSlider';
exports.StyledCompactSliderTrackLine = styled_components_1.default.div ``;
exports.StyledCompactSliderTrackArea = styled_components_1.default.div `
    ${({ fillPercent, disabled, theme }) => (0, styled_components_1.css) `
        width: 100%;
        height: ${trackConfig.areaClickHeight};
        left: 0;
        top: calc((${exports.compactSliderThumbSize} - ${trackConfig.areaClickHeight}) / 2);
        position: absolute;
        overflow: visible;

        ${exports.StyledCompactSliderTrackLine} {
            position: absolute;
            height: ${trackConfig.height};
            top: calc((${trackConfig.areaClickHeight} - ${trackConfig.height}) / 2);
            left: 0;
            right: 0;
            background-color: ${disabled
    ? theme.colorControlBorderDisabled
    : theme.colorBorderMain};

            &:before {
                content: '';
                position: absolute;
                height: ${trackConfig.height};
                width: ${fillPercent}%;
                background-color: ${disabled
    ? theme.colorControlBorderDisabled
    : theme.colorControlIcon};
            }
        }
    `}
`;
exports.StyledCompactSliderControl = styled_components_1.default.div `
    box-sizing: border-box;
    width: ${exports.compactSliderThumbSize};
    height: ${exports.compactSliderThumbSize};
    border: 0;
    outline: none;
    z-index: 1;
    position: absolute;
    border-radius: 50%;

    ${({ position, disabled, theme }) => (0, styled_components_1.css) `
        top: calc((${trackConfig.areaClickHeight} - ${exports.compactSliderThumbSize}) / 2);
        left: calc(${position}% - (${exports.compactSliderThumbSize} * ${position}) / 100);
        background-color: ${disabled ? theme.colorControlBorderDisabled : theme.colorControlIcon};
    `}
`;
exports.StyledCompactSliderPoint = styled_components_1.default.div `
    ${({ leftValue }) => (0, styled_components_1.css) `
        left: calc(
            ${leftValue}% - (${pointConfig.width} - ${pointConfig.internalCircleWidth}) / 2 -
                (${pointConfig.internalCircleWidth} * ${leftValue}) / 100
        );
        top: calc((${trackConfig.areaClickHeight} - ${pointConfig.width}) / 2);
        position: absolute;
        -webkit-appearance: none;
        border: 0;
        border-radius: 50%;
        height: ${pointConfig.width};
        width: ${pointConfig.width};

        &:after {
            content: '';
            position: absolute;
            left: calc((${pointConfig.width} - ${pointConfig.internalCircleWidth}) / 2);
            top: calc((${pointConfig.width} - ${pointConfig.internalCircleWidth}) / 2);
            border-radius: 50%;
            width: ${pointConfig.internalCircleWidth};
            height: ${pointConfig.internalCircleWidth};
        }
    `}

    ${({ theme, isFilled, disabled, interactiveMode }) => {
    if (disabled) {
        return (0, styled_components_1.css) `
                &:after {
                    background: ${theme.colorControlBorderDisabled};
                }
            `;
    }
    if (isFilled && interactiveMode) {
        return (0, styled_components_1.css) `
                &:after {
                    background: ${theme.colorControlIcon};
                }

                &:hover {
                    background-color: ${theme.colorHighlightLight};
                }

                &:active {
                    background-color: ${theme.colorHighlightDark};
                }
            `;
    }
    if (isFilled) {
        return (0, styled_components_1.css) `
                &:after {
                    background: ${theme.colorControlIcon};
                }
            `;
    }
    if (interactiveMode) {
        return (0, styled_components_1.css) `
                &:after {
                    background: ${theme.colorBorderMain};
                }

                &:hover {
                    background-color: ${theme.colorHighlightLight};
                }

                &:active {
                    background-color: ${theme.colorHighlightDark};
                }

                &:hover,
                &:active {
                    &:after {
                        background: ${theme.colorControlIcon};
                    }
                }
            `;
    }
    return (0, styled_components_1.css) `
            &:after {
                background: ${theme.colorBorderMain};
            }
        `;
}}
`;
//# sourceMappingURL=CompactSlider.styles.js.map